import { get, post } from '@/utils/request';

// export const contractFxqCheck = (params) => {
//   return post('/api/v1/check_contract', params);
// };
export const queryContract = (params) => {
  return post('/api/v1/query_contract', params);
};
export const updatePayVoucher = (params) => {
  return post('/api/v1/update_pay_voucher', params);
};
export const contractSaveByProject = (params) => {
  return post('/api/v1/contract_save_by_project', params);
};
export const otherDoContract = (params) => {
  return post('/api/v1/other_do_contract', params);
};
export const saveSignRdis = (params) => {
  return post('/api/v1/save_sign_rdis', params);
};
export const stepSignContent = (params) => {
  return post('/api/v1/step_sign_content', params);
};
export const contract_puser_change = (params) => {
  return post('/api/v1/contract_puser_change', params);
};
export const contract_invoice_applye = (params) => {
  return post('/api/v1/contract_invoice_applye', params);
};
export const contract_cancel = (params) => {
  return post('/api/v1/contract_cancel', params);
};
export const sms_notice_send = (params) => {
  return post('/api/v1/sms_notice_send', params);
};
export const contract_del = (params) => {
  return post('/api/v1/contract_del', params);
};
export const contractStatusCount = (params) => {
  return get('/api/v1/contract_status_count', params);
};
export const contracts = (params) => {
  return get('/api/v1/contracts', params);
};
export const exportContracts = (params) => {
  return get('/api/v1/export_contracts', params);
};
export const contractsByPuser = (params) => {
  return get('/api/v1/contracts_by_puser', params);
};
export const exportContractsByPuser = (params) => {
  return get('/api/v1/export_p_contracts', params);
};
export const contracts_linhai = (params) => {
  return get('/api/v1/contracts_linhai', params);
};
export const contract_linhai_statistics = (params) => {
  return get('/api/v1/contract_linhai_statistics', params);
};
export const contracts_wenling = (params) => {
  return get('/api/v1/contracts_wenling', params);
};
export const contract_wenling_statistics = (params) => {
  return get('/api/v1/contract_wenling_statistics', params);
};

export const contracts_yuhuan = (params) => {
  return get('/api/v1/contracts_yuhuan', params);
};
export const contract_yuhuan_statistics = (params) => {
  return get('/api/v1/contract_yuhuan_statistics', params);
};
export const contracts_liaoning = (params) => {
  return get('/api/v1/contracts_liaoning', params);
};
export const contract_liaoning_statistics = (params) => {
  return get('/api/v1/contract_liaoning_statistics', params);
};
export const contract = (id) => {
  return get(`/api/v1/contract/${id}`);
};
export const contract_by_uuid = (id,uuid) => {
  return get(`/api/v1/contract/${id}/${uuid}`);
};
export const contract_ca_by_uuid = (id, uuid) => {
  return get(`/api/v1/contract_ca/${id}/${uuid}`);
};
export const contract_statuss = (params) => {
  return get('/api/v1/contract_statuss', params);
};
export const exportContractLinhai = (params) => {
  return get('/api/v1/export_contract_linhai', params);
};
export const exportContractWenling = (params) => {
  return get('/api/v1/export_contract_wenling', params);
};
export const exportContractLiaoning = (params) => {
  return get('/api/v1/export_contract_liaoning', params);
};
export const contract_id_records = (params) => {
  return get('/api/v1/contract_id_records', params);
};
export const contractCheck = (id) => {
  return get('/api/v1/contract_check?id=' + id);
};

export function contractThirdPay(id) {
  return get('/api/v1/third_pay?id=' + id);
}

export function contractPointPay(id) {
  return get('/api/v1/pointpay/' + id);
}
